import { ComplexValue, Value } from "app/types-shared";

export const subscriberGroupOptionsMapped = (list: Value[]): ComplexValue<number>[] =>
  list.map(item => ({
    value: item.v,
    description: item.d
  }));
